import React from "react";

const Java_print = () => {
  return (
    <div>
      <h1>Java print()</h1>
      <p>This page provides explanations, examples, and common use-cases for Java print() in Java.</p>
    </div>
  );
};

export default Java_print;
